import { render } from "./Bundles.vue?vue&type=template&id=42e09350&scoped=true"
import script from "./Bundles.vue?vue&type=script&lang=js"
export * from "./Bundles.vue?vue&type=script&lang=js"

import "./Bundles.vue?vue&type=style&index=0&id=42e09350&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-42e09350"

export default script